import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useContext } from 'react';
import { TabsContext } from './index.js';

var _excluded = ["as", "className", "name"];
var TabsContent = function TabsContent(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    name = _ref.name,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(TabsContext),
    activeTab = _useContext.activeTab;
  var finalClasses = classnames('C-Tabs__Content', {
    isActive: name && activeTab && name === activeTab
  }, className);
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses
  }, otherProps, {
    tabIndex: "0",
    role: "tabpanel",
    id: "".concat(name, "-tab-panel"),
    "aria-labelledby": "".concat(name, "-tab-control"),
    hidden: name && activeTab && name === activeTab ? false : true
  }));
};
TabsContent.displayName = 'Tabs.Content';

export { TabsContent, TabsContent as default };
